import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../auth/AuthContext';
import { useApiFetch } from '../api/fetcher';
import { ACCOUNT_URL } from '../api/urls';
import type { RootState } from '../app/store';
import userIdentReducer, { setUserIdent } from '../app/userSlice';
import { store } from '../app/store';

if (!(store as any).asyncReducers) {
  (store as any).asyncReducers = {};
}
if (!(store as any).asyncReducers.userIdent) {
  (store as any).asyncReducers.userIdent = userIdentReducer;
  store.replaceReducer(
    (state: any, action: any) => ({
      ...state,
      userIdent: userIdentReducer(state?.userIdent, action),
    })
  );
}

const UsetifulLoader: React.FC = () => {
  const { isAuthenticated, isInitializing } = useAuth() as any;
  const apiFetch = useApiFetch();
  const dispatch = useDispatch();
  const userIdent = useSelector((s: RootState & { userIdent: any }) => s.userIdent);
  const injectedRef = React.useRef(false);

  React.useEffect(() => {
    if (isInitializing || !isAuthenticated) return;
    let cancelled = false;
    (async () => {
      try {
        if (!userIdent?.loaded) {
          const res = await apiFetch(ACCOUNT_URL, { credentials: 'include' });
          const json = await res.json();
          if (cancelled) return;
          const userId = String(json?.id ?? '');
          const firstName = String(json?.username ?? '');
          const lastName = String(json?.account_name ?? '');
          dispatch(setUserIdent({ userId, firstName, lastName }));
        }
      } catch {}
    })();
    return () => { cancelled = true; };
  }, [apiFetch, dispatch, isAuthenticated, isInitializing, userIdent?.loaded]);

  React.useEffect(() => {
    if (!isAuthenticated || !userIdent?.loaded) return;
    if (injectedRef.current) return;

    (window as any).usetifulTags = {
      userId: userIdent.userId ?? '',
      firstName: userIdent.firstName ?? '',
      lastName: userIdent.lastName ?? '',
    };

    const head = document.getElementsByTagName('head')[0];
    const existing = document.getElementById('usetifulScript');
    if (!existing) {
      const r = document.createElement('script');
      r.async = true as any;
      r.src = 'https://www.usetiful.com/dist/usetiful.js';
      r.setAttribute('id', 'usetifulScript');
      (r as any).dataset.token = 'b097ac33c8099edbd85eec95e6b2c0e6';
      head.appendChild(r);
    } else {
      (window as any).usetifulTags = {
        userId: userIdent.userId ?? '',
        firstName: userIdent.firstName ?? '',
        lastName: userIdent.lastName ?? '',
      };
    }

    injectedRef.current = true;
  }, [isAuthenticated, userIdent]);

  return null;
};

export default UsetifulLoader; 